import { AspectRatio, Flex, Stack, Text, VStack } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import TextLink from '@components/interactive/TextLink';
import WizardLayout from '@components/layout/layout/WizardLayout';
import Body1 from '@components/typography/Body1';
import Body2 from '@components/typography/Body2';
import Header from '@components/typography/Header';
import { useWizard } from '@contexts/WizardContextProvider';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const IntroductionPage = () => {
  const { user, setUser } = useWizard();
  const router = useRouter();
  const hasUpdatedUtm = useRef(false);
  const hasClearedPartner = useRef(false);

  const { utm_source } = router.query;

  useEffect(() => {
    if (utm_source && !hasUpdatedUtm.current) {
      setUser({ ...user, utm_source: String(utm_source) });
      hasUpdatedUtm.current = true;
    }
  }, [utm_source, setUser, user]);

  // clear partner since this is the default wizard.
  useEffect(() => {
    if (!hasClearedPartner.current) {
      setUser({ ...user, partner: null });
      hasClearedPartner.current = true;
    }
  }, [setUser, user]);

  return (
    <WizardLayout maxWidth="1200px">
      <VStack align="stretch" maxW="1200px" mx="auto" gap={0}>
        <Header as="h2" fontSize={[24, 24, 32, 36]}>
          Hi, I'm Dan.
        </Header>
        <Flex direction={['column', 'column', 'row']} gap={[8, 8, 12]} align="center">
          <AspectRatio
            order={[0, 0, 1]}
            minW={['120px', '120px', '200px']}
            maxW={['120px', '120px', '200px']}
            minH={['120px', '120px', '200px']}
            borderRadius="full"
            overflow="hidden"
          >
            <Image src="/headshots/dan.jpeg" alt="Dan's headshot" fill style={{ objectFit: 'cover' }} />
          </AspectRatio>
          <Stack order={[1, 1, 0]} spacing={4} flex={1}>
            <Text textStyle="wizard">
              I'm the Founder and CEO of Fair Square Medicare. My parents struggled to navigate the Medicare maze, so I
              started Fair Square Medicare - the Medicare shopping experience I wish they had.
            </Text>
            <Body1 textStyle="wizard">Are you enrolling in Medicare for the first time or are you already on it?</Body1>
          </Stack>
        </Flex>
        <Flex direction={['column', 'column', 'row']} gap={4} align="center" pt={4}>
          <Button href="/guide/new-to-medicare/birthday" width="100%" maxWidth="300px">
            New to Medicare
          </Button>
          <Button variant="secondary" href="/guide/current-beneficiary/medigap-or-ma" width="100%" maxWidth="300px">
            Already on Medicare
          </Button>
        </Flex>
        <Flex align="center" gap={2} pt={4}>
          <Body2>On Medicare due to disability? </Body2>
          <TextLink href="/call-us" text="Call us." />
        </Flex>
      </VStack>
    </WizardLayout>
  );
};

export default IntroductionPage;
